import React from 'react';

export const ChartSkeleton: React.FC = () => (
  <div className="skeleton skeleton-chart" />
);

export const PieChartSkeleton: React.FC = () => (
  <div className="skeleton skeleton-pie" />
);

export const CategoryListSkeleton: React.FC = () => (
  <div style={{ padding: '16px 0' }}>
    {[...Array(5)].map((_, index) => (
      <div key={index} className="skeleton-category-item">
        <div className="skeleton skeleton-category-color" />
        <div className="skeleton skeleton-category-name" />
        <div className="skeleton skeleton-category-amount" />
      </div>
    ))}
  </div>
);

export const ExpenseTableSkeleton: React.FC = () => (
  <div className="skeleton-table">
    {[...Array(12)].map((_, index) => (
      <div key={index} className="skeleton-table-row">
        <div className="skeleton skeleton-table-cell date" />
        <div className="skeleton skeleton-table-cell name" />
        <div className="skeleton skeleton-table-cell category" />
        <div className="skeleton skeleton-table-cell amount" />
        <div className="skeleton skeleton-table-cell actions" />
      </div>
    ))}
  </div>
);

interface StatsSkeletonProps {
  count?: number;
}

export const StatsSkeleton: React.FC<StatsSkeletonProps> = ({ count = 3 }) => (
  <div style={{ display: 'flex', gap: '16px', justifyContent: 'center' }}>
    {[...Array(count)].map((_, index) => (
      <div key={index} style={{ textAlign: 'center' }}>
        <div className="skeleton" style={{ width: '80px', height: '24px', margin: '0 auto 8px' }} />
        <div className="skeleton" style={{ width: '60px', height: '16px', margin: '0 auto' }} />
      </div>
    ))}
  </div>
);

export const SelectSkeleton: React.FC = () => (
  <div className="skeleton" style={{ width: '100%', height: 'var(--input-height, 44px)', borderRadius: '4px' }} />
);
